import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04ac9df1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rich-menu-wrapper main-content-wrapper",
  id: "step-setting"
}
const _hoisted_2 = { class: "main-content-page-title" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex justify-content-center" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(['inline-flex align-items-center justify-content-center align-items-center z-1'])
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs step-name-description" }, "Step", -1))
const _hoisted_7 = { class: "text-2xl step-name-description" }
const _hoisted_8 = { class: "flex justify-content-center" }
const _hoisted_9 = {
  id: "pv_id_1",
  class: "p-steps p-component custom-steps w-70"
}
const _hoisted_10 = { class: "p-steps-list" }
const _hoisted_11 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass([
                  'inline-flex align-items-center justify-content-center align-items-center h-6rem w-7rem z-1 cursor-pointer step-container bg-white',
                  'incoming-container',
                ])
}
const _hoisted_12 = { class: "text-small step-name-title font-bold" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }

import { ref } from "vue";
import { set } from "@vueuse/core";

// PrimeVueコンポーネントのインポート
import Steps from "primevue/steps";

// 子コンポーネントのインポート
import DeliverySetting from "./DeliverySetting.vue";
import TargetSetting from "./TargetSetting.vue";
import MessageSetting from "./MessageSetting.vue";
import BasicSetting from "./BasicSetting.vue";
import FinalSetting from "./FinalSetting.vue";
import TargetCustomers from "./TargetCustomers.vue";

// サービスのインポート
import DistributionGroupService from "@/clinic/services/distribution_group_service";

/**
 * 現在のステップインデックス（1-5）
 * @type {Ref<number>}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    isEdit: { type: Boolean },
    groupId: null,
    basicInformation: null,
    messageSetting: null,
    targetInformation: null,
    deliverySetting: null
  },
  setup(__props: any) {

const props = __props as {
  /** 編集モードかどうか */
  isEdit: boolean;
  /** 配信グループID */
  groupId: number;
  /** 基本情報 */
  basicInformation: any;
  /** メッセージ設定 */
  messageSetting: any;
  /** ターゲット情報 */
  targetInformation: any;
  /** 配信設定 */
  deliverySetting: any;
};

/**
 * 配信グループ作成・編集フォームのメインコンポーネント
 *
 * このコンポーネントは配信グループの作成・編集プロセスを管理し、
 * 以下の5つのステップで構成されています：
 * 1. グループ設定
 * 2. ターゲット設定
 * 3. 配信設定
 * 4. メッセージ設定
 * 5. 設定完了
 *
 * @component Form
 * @description 配信グループの作成・編集フォームのメインコンポーネント
 */

// Vue関連のインポート
const activeIndex = ref(1);

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */


/**
 * ページタイトル
 * @type {string}
 */
const pageTitle = props.isEdit ? "配送グループの編集" : "新規配信グループの作成";

/**
 * 最終設定モードかどうか
 * @type {Ref<boolean>}
 */
const currentFinalSetting = ref(false);

/**
 * 配信設定情報
 * @type {Ref<any>}
 */
const deliverySetting = ref(props.deliverySetting);

/**
 * 基本情報
 * @type {Ref<any>}
 */
const basicInformation = ref(props.basicInformation);

/**
 * 配信グループID
 * @type {Ref<string | number>}
 */
const distributionGroupId = ref(props.groupId);

/**
 * メッセージ設定情報
 * @type {Ref<any>}
 */
const messageSetting = ref(props.messageSetting);

/**
 * ターゲット情報
 * @type {Ref<any>}
 */
const targetInformation = ref(props.targetInformation);

/**
 * ターゲットビューの種類（'setting' | 'list'）
 * @type {Ref<string>}
 */
const targetView = ref("setting");

/**
 * ターゲット顧客リスト
 */
const targetCustomers = ref<any[]>([]);

/**
 * 除外された顧客コードのリスト
 * @type {Ref<any[]>}
 */
const rejectedCustomerCodes = ref<any[]>([]);

/**
 * ステップの設定情報
 * @type {Ref<Array<{step: number, name: string}>>}
 */
const items = ref([
  {
    step: 1,
    name: "グループ 設定",
  },
  {
    step: 2,
    name: "ターゲット 設定",
  },
  {
    step: 3,
    name: "配信設定",
  },
  {
    step: 4,
    name: "メッセージ 設定",
  },
  {
    step: 5,
    name: "設定完了",
  },
]);

/**
 * 編集成功時の処理
 * フォームを初期状態にリセットする
 */
const onEditSuccess = () => {
  activeIndex.value = 1;
  currentFinalSetting.value = false;
  deliverySetting.value = {};
  basicInformation.value = {};
  distributionGroupId.value = 0;
  messageSetting.value = {};
  targetInformation.value = {};
  targetView.value = "setting";
  targetCustomers.value = [];
};

/**
 * 最終設定から戻る時の処理
 * @param {number} index - 戻るステップのインデックス
 * @param {boolean} setting - 最終設定モードかどうか
 */
const onBackWithFinalSetting = (index: number, setting: boolean) => {
  activeIndex.value = index;
  currentFinalSetting.value = setting;
  targetView.value = "setting";
};

/**
 * 基本情報保存時の処理
 * @param {number} index - 次のステップのインデックス
 * @param {any} data - 保存されたデータ
 */
const onSaveBasicInformation = (index: number, data: any) => {
  activeIndex.value = currentFinalSetting.value ? 5 : index;
  basicInformation.value = data.data.value;
  distributionGroupId.value = basicInformation.value.id;
};

/**
 * 配信設定保存時の処理
 * @param {number} index - 次のステップのインデックス
 * @param {any} data - 保存されたデータ
 */
const onSaveDeliverySetting = (index: number, data: any) => {
  deliverySetting.value = data;
  activeIndex.value = index;
};

/**
 * メッセージ設定保存時の処理
 * @param {number} index - 次のステップのインデックス
 * @param {any} data - 保存されたデータ
 */
const onSaveMessageSetting = (index: number, data: any) => {
  messageSetting.value = data;
  activeIndex.value = index;
};

/**
 * ターゲット情報保存時の処理
 * @param {any} data - 保存されたターゲット情報
 */
const onTargetInformation = (data: any) => {
  targetInformation.value = data;
  activeIndex.value = currentFinalSetting.value ? 5 : 3; // 次のステップ（配信設定）に進む
};

/**
 * リソース関数の実行
 * @param {number} index - 設定するステップのインデックス
 */
const onResourcesFn = (index: number) => {
  targetView.value = "setting";
  activeIndex.value = index;
};

/**
 * ターゲットビュータイプの変更
 * @param {string} type - 新しいビュータイプ
 */
const onChangeTargetViewType = (type: string) => {
  targetView.value = type;
};

/**
 * ターゲット顧客保存時の処理
 * @param {any} data - 保存された顧客データ
 * @param {number} index - 次のステップのインデックス
 */
const onSaveTargetCustomers = async (data: any, index: number) => {
  if (JSON.stringify(data) != JSON.stringify(targetInformation.value)) {
    const response = await DistributionGroupService.saveTargetCustomers(distributionGroupId.value, data);
    set(targetCustomers, response.data.value.customers);
    set(rejectedCustomerCodes, []);
  }
  set(targetInformation, data);
  targetView.value = "list";

  if (index) {
    activeIndex.value = currentFinalSetting.value ? 5 : index;
  }
};

/**
 * 除外された顧客IDの設定
 * @param {number | string | any[]} data - 除外する顧客ID
 */
const onSetRejectedCustomerIds = (data: number | string | any[]) => {
  if (Array.isArray(data)) rejectedCustomerCodes.value.push(...data);
  else rejectedCustomerCodes.value.push(data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(activeIndex.value == 5 ? "配信設定確認" : _unref(pageTitle)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Steps), {
          model: items.value,
          class: "custom-steps step-name w-70",
          readonly: false
        }, {
          item: _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex flex-column step-number", [{ 'active-step': activeIndex.value == item.step, 'done-step': activeIndex.value > item.step }]])
              }, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, "0" + _toDisplayString(item.step) + ".", 1)
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("nav", _hoisted_9, [
          _createElementVNode("ol", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["p-steps-item", [{ 'done-step': activeIndex.value > item.step }]]),
                key: index
              }, [
                (item.step != 5)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([
                  'inline-flex align-items-center justify-content-center align-items-center h-6rem w-7rem z-1 cursor-pointer step-container bg-white',
                  { 'bg-custom': activeIndex.value == item.step },
                  {
                    'done-step-container':
                      (currentFinalSetting.value && activeIndex.value != item.step) ||
                      (activeIndex.value > item.step && activeIndex.value != item.step),
                  },
                  {
                    'incoming-container':
                      (activeIndex.value == 3 && item.step == 4) ||
                      (!currentFinalSetting.value && activeIndex.value < item.step && activeIndex.value != item.step),
                  },
                ])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                    'text-small step-name-title',
                    { 'font-bold': activeIndex.value == item.step },
                    {
                      'font-bold':
                        (activeIndex.value == 3 && item.step == 4) ||
                        (!currentFinalSetting.value && activeIndex.value < item.step && activeIndex.value != item.step),
                    },
                    {
                      'font-light':
                        (currentFinalSetting.value && activeIndex.value != item.step) ||
                        (activeIndex.value > item.step && activeIndex.value != item.step),
                    },
                  ])
                      }, _toDisplayString(item.name), 3)
                    ], 2))
                  : _createCommentVNode("", true),
                (item.step == 5)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ])
      ]),
      (activeIndex.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(BasicSetting, {
              distributionGroupId: distributionGroupId.value,
              onSaveBasicInformation: onSaveBasicInformation,
              basicInformation: basicInformation.value,
              finalSetting: false,
              isEdit: __props.isEdit
            }, null, 8, ["distributionGroupId", "basicInformation", "isEdit"])
          ]))
        : _createCommentVNode("", true),
      (activeIndex.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (targetView.value == 'setting')
              ? (_openBlock(), _createBlock(TargetSetting, {
                  key: 0,
                  onResourcesFn: onResourcesFn,
                  onChangeTargetViewType: onChangeTargetViewType,
                  onSaveTargetCustomers: onSaveTargetCustomers,
                  onSaveTargetInformation: onTargetInformation,
                  distributionGroupId: distributionGroupId.value,
                  targetInformation: targetInformation.value,
                  finalSetting: false,
                  rejectedCustomerCodes: rejectedCustomerCodes.value,
                  isEdit: __props.isEdit
                }, null, 8, ["distributionGroupId", "targetInformation", "rejectedCustomerCodes", "isEdit"]))
              : _createCommentVNode("", true),
            (targetView.value == 'list')
              ? (_openBlock(), _createBlock(TargetCustomers, {
                  key: 1,
                  onResourcesFn: onResourcesFn,
                  targetCustomers: targetCustomers.value,
                  onSetRejectedCustomerIds: onSetRejectedCustomerIds,
                  distributionGroupId: distributionGroupId.value
                }, null, 8, ["targetCustomers", "distributionGroupId"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (activeIndex.value === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(DeliverySetting, {
              onResourcesFn: onResourcesFn,
              distributionGroupId: distributionGroupId.value,
              deliverySetting: deliverySetting.value,
              onSaveDeliverySetting: onSaveDeliverySetting,
              finalSetting: false,
              isEdit: __props.isEdit,
              onChangeTargetViewType: onChangeTargetViewType
            }, null, 8, ["distributionGroupId", "deliverySetting", "isEdit"])
          ]))
        : _createCommentVNode("", true),
      (activeIndex.value === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(MessageSetting, {
              onResourcesFn: onResourcesFn,
              distributionGroupId: String(distributionGroupId.value),
              deliverySetting: deliverySetting.value,
              messageSetting: messageSetting.value,
              onSaveMessageSetting: onSaveMessageSetting,
              finalSetting: false,
              isEdit: __props.isEdit
            }, null, 8, ["distributionGroupId", "deliverySetting", "messageSetting", "isEdit"])
          ]))
        : _createCommentVNode("", true),
      (activeIndex.value === 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(FinalSetting, {
              distributionGroupId: distributionGroupId.value,
              onResourcesFn: onResourcesFn,
              onBackWithFinalSetting: onBackWithFinalSetting,
              onEditSuccess: onEditSuccess,
              basicInformation: basicInformation.value,
              targetInformation: targetInformation.value,
              deliverySetting: deliverySetting.value,
              messageSetting: messageSetting.value,
              isEdit: __props.isEdit
            }, null, 8, ["distributionGroupId", "basicInformation", "targetInformation", "deliverySetting", "messageSetting", "isEdit"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})